import { render, staticRenderFns } from "./SectionClientSlider.vue?vue&type=template&id=7a6da646&scoped=true"
import script from "./SectionClientSlider.vue?vue&type=script&lang=js"
export * from "./SectionClientSlider.vue?vue&type=script&lang=js"
import style0 from "./SectionClientSlider.vue?vue&type=style&index=0&id=7a6da646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6da646",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogoSlider: require('/builds/marketing/abstracta.academy-website/components/LogoSlider.vue').default})
